import React, { useContext } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import AppContext from '../../AppContext';
import { getTranslateByScope } from '../../i18n';
import { UNISEX_CLUSTER } from '../../constants';
import { getProductsAvailableClusters } from '../../selectors';
import { navigateToProductListWithClusters } from '../../utils/navigations';
import { join } from '../../utils/strings';
import { ClusterLayout } from './ClusterLayout';

const translate = getTranslateByScope('app.clusters.unisexClusters');

// Clusters look like "WG1|Gender|Activity|Category|Type" - list the WG1 of
// every unisex product. Unisex is independent of the Herren/Damen picker.
export const UnisexClusters = withRouter(({ history, onSelectCluster }) => {
  const context = useContext(AppContext);
  const wg1s = getProductsAvailableClusters(context)
    .map((c) => c.split('|'))
    .filter((parts) => parts[1] === UNISEX_CLUSTER)
    .map((parts) => _.head(parts));

  const onClick = (wg1) => {
    onSelectCluster();
    navigateToProductListWithClusters({
      history,
      clusters: join({ part1: UNISEX_CLUSTER, part2: wg1, separator: '|' }),
    });
  };

  return (
    <ClusterLayout
      clusters={_.compact(wg1s)}
      title={translate('title')}
      onClick={onClick}
    />
  );
});
